module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av762-6f83b12b0c9210e7718c91e2b335d492.jpg";